<template>
  <Button
    :id="id"
    @click="openShare"
    class="flex items-center !bg-ash-500 gap-[0.4642857rem] cursor-pointer font-medium !rounded-[0.4285rem] lg:pl-[0.714rem] lg:pr-[1rem] pt-[0.4285714rem] pb-[0.5rem] border-gray-900 border hover:border-gray-600 hover:!bg-gray-600 text-[1rem]"
    variant="primary"
    theme="LIGHT"
    size="md"
    :aria-label="ariaLabel">
    <slot />
  </Button>
</template>

<script setup lang="ts">
import Button from '../atom/button.vue'
import { buildShareUrls } from '~~/shared/utils/share.config'
import type { ShareNetwork } from '~~/shared/utils/share.config'

interface Props {
  network?: ShareNetwork
  url?: string | null
  title?: string | null
  videoId?: string | null
  ariaLabel?: string | null
  id?: string
}

const props = defineProps<Props>()

const openShare = async () => {
  const network = props.network

  switch (network) {
    case 'facebook':
      window.open(
        buildShareUrls.facebook(props.url ?? '', props.title ?? ''),
        '_blank',
        'noopener,noreferrer,width=600,height=500'
      )
      break

    case 'twitter':
      window.open(
        buildShareUrls.twitter(props.url ?? '', props.title ?? ''),
        '_blank',
        'noopener,noreferrer,width=600,height=500'
      )
      break

      case 'copy':
       try {
        const textToCopy = buildShareUrls.copy(props.url)
        await navigator.clipboard.writeText(textToCopy)
       } catch (err) {
        console.error('Failed to copy link', err)
       }
      break
    
    case 'youtubeWatch':
      if (props.videoId) {
        window.open(
          buildShareUrls.youtubeWatch(props.videoId),
          '_blank',
          'noopener,noreferrer'
        )
      }
      break

    default:
      if (props.url) {
        window.open(props.url, '_blank', 'noopener,noreferrer,width=600,height=500')
      }
  }
}
</script>
